import { useMutation, useQuery } from "@tanstack/react-query";
import { RefreshReactQuery } from "../../constants/AppConstants";
import ConfigurationsService from "../../services/api/configurations/Configurations.service";
import { useEffect } from "react";
import { useNotification } from "../notification.hook";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../../constants/Dictionary";

const MANAGE_CONFIG_QUERY_KEY = "get-configurations";

interface useManageCmSheetProps {
  enabled: boolean;
}

export const useCmSheetConfigurations = ({
  enabled,
}: useManageCmSheetProps) => {
  const { notification } = useNotification();
  const {
    data: config,
    isFetching,
    isError,
  } = useQuery({
    queryKey: [MANAGE_CONFIG_QUERY_KEY],
    queryFn: () => ConfigurationsService.get(),
    enabled,
    staleTime: RefreshReactQuery.HIGH,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { config, isFetching };
};

export const useCreateCmSheetConfig = () => {
  const { mutateAsync: confirmConfig, isPending: isConfirmConfigLoading } =
    useMutation({
      mutationKey: ["create-cmSheet-confirm-config"],
      mutationFn: () => ConfigurationsService.confirm(),
    });

  return { confirmConfig, isConfirmConfigLoading };
};
